import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FinancingOptions = () => {
  const [activeBank, setActiveBank] = useState(0);

  const banks = [
    { name: 'Emirates NBD', type: 'Local Bank', maxLTV: '75%', rate: '4.49%', minIncome: 'AED 15,000/mo', features: ['Pre-approval in 48hrs', 'Multi-currency income accepted', 'Salary transfer not required for expats'] },
    { name: 'HSBC UAE', type: 'International', maxLTV: '75%', rate: '4.25%', minIncome: 'AED 20,000/mo', features: ['Global income recognition', 'Existing HSBC customers preferred', 'Fast-track for Premier clients'] },
    { name: 'Mashreq Bank', type: 'Local Bank', maxLTV: '70%', rate: '4.65%', minIncome: 'AED 12,000/mo', features: ['Flexible income documentation', 'Self-employed friendly', 'Islamic finance option available'] },
    { name: 'Abu Dhabi Commercial Bank', type: 'Local Bank', maxLTV: '75%', rate: '4.35%', minIncome: 'AED 15,000/mo', features: ['Competitive expat rates', 'Salary transfer bonus rate', 'Free property valuation'] },
    { name: 'Standard Chartered', type: 'International', maxLTV: '70%', rate: '4.55%', minIncome: 'AED 18,000/mo', features: ['International income accepted', 'Priority banking benefits', 'Dedicated relationship manager'] },
  ];

  const requirements = [
    { label: 'Down Payment (Expat)', value: '25–30%', icon: 'DollarSign', note: 'vs 20% for UAE nationals' },
    { label: 'Max Loan Tenure', value: '25 Years', icon: 'Calendar', note: 'Up to age 65 at maturity' },
    { label: 'Max LTV Ratio', value: '75%', icon: 'Percent', note: 'For properties under AED 5M' },
    { label: 'Debt Burden Ratio', value: 'Max 50%', icon: 'BarChart2', note: 'Of monthly income' },
  ];

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)' }}>
          <Icon name="Landmark" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Expat Mortgage Options</h3>
          <p className="text-sm" style={{ color: '#6B9EC4' }}>UAE bank partnerships with expat-friendly terms</p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {requirements?.map((req, idx) => (
          <div key={idx} className="p-3 rounded-xl text-center" style={{ background: 'rgba(0, 212, 255, 0.05)', border: '1px solid rgba(0, 212, 255, 0.15)' }}>
            <Icon name={req?.icon} size={16} color="#00D4FF" />
            <div className="text-base font-bold mt-1" style={{ color: '#00D4FF' }}>{req?.value}</div>
            <div className="text-xs font-medium" style={{ color: '#E8F4FF' }}>{req?.label}</div>
            <div className="text-xs mt-0.5" style={{ color: '#4A7A9B' }}>{req?.note}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mb-4 flex-wrap">
        {banks?.map((bank, idx) => (
          <button
            key={idx}
            onClick={() => setActiveBank(idx)}
            className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200"
            style={activeBank === idx ? { background: 'rgba(0, 212, 255, 0.2)', border: '1px solid rgba(0, 212, 255, 0.6)', color: '#00D4FF' } : { background: 'rgba(0, 212, 255, 0.05)', border: '1px solid rgba(0, 212, 255, 0.15)', color: '#6B9EC4' }}
          >
            {bank?.name}
          </button>
        ))}
      </div>
      <div className="p-5 rounded-xl" style={{ background: 'rgba(0, 212, 255, 0.06)', border: '1px solid rgba(0, 212, 255, 0.25)' }}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h4 className="font-bold" style={{ color: '#E8F4FF' }}>{banks?.[activeBank]?.name}</h4>
            <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(0, 212, 255, 0.1)', color: '#00D4FF' }}>{banks?.[activeBank]?.type}</span>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold" style={{ color: '#00D4FF', fontFamily: "'JetBrains Mono', monospace" }}>{banks?.[activeBank]?.rate}</div>
            <div className="text-xs" style={{ color: '#6B9EC4' }}>Starting Rate p.a.</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="p-3 rounded-lg" style={{ background: 'rgba(10, 22, 40, 0.6)' }}>
            <div className="text-xs" style={{ color: '#6B9EC4' }}>Max LTV</div>
            <div className="font-bold" style={{ color: '#E8F4FF' }}>{banks?.[activeBank]?.maxLTV}</div>
          </div>
          <div className="p-3 rounded-lg" style={{ background: 'rgba(10, 22, 40, 0.6)' }}>
            <div className="text-xs" style={{ color: '#6B9EC4' }}>Min Monthly Income</div>
            <div className="font-bold" style={{ color: '#E8F4FF' }}>{banks?.[activeBank]?.minIncome}</div>
          </div>
        </div>
        <div className="space-y-2">
          {banks?.[activeBank]?.features?.map((f, i) => (
            <div key={i} className="flex items-center gap-2">
              <Icon name="CheckCircle" size={14} color="#00FF88" />
              <span className="text-sm" style={{ color: '#6B9EC4' }}>{f}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancingOptions;